import BaseModel from "../BaseModel";

export default class EmailTemplate extends BaseModel{
	static entity = 'emailTemplates';
	static fields(){
		return {
			id: this.attr(null),
			email_type_id: this.attr(null),
			title: this.attr(null),
			subject: this.attr(null),
			body: this.attr(null),
			user_id: this.attr(null)
		}
	}
	static ignoredLogFields(){
		return ['created_at', 'updated_at']
	}
	static route(){
		return '/email/templates'
	}
}
